import { gql } from '@urql/core';
import { HighSchoolProfileFragment } from 'generated/spin-graphql';
import React from 'react';
import { HighSchoolBioCard } from './HighSchoolBioCard';
import { HighSchoolLocationCard } from './HighSchoolLocationCard';
import { HighSchoolOurTeamsCard } from './HighSchoolOurTeamsCard';
import { OurEsportsCard } from './OurEsportsCard';

gql`
    fragment HighSchoolProfile on espin_high_school {
        name
        ...HighSchoolBioCard
        ...HighSchoolLocationCard
        ...HighSchoolOurTeamsCard
        ...HighSchoolOurEsportsCard
    }
`;

export function HighSchoolProfile({ highSchool }: { highSchool: HighSchoolProfileFragment }) {
    return (
        <>
            <div className="left-side-profile">
                <HighSchoolBioCard highSchool={highSchool} />
                <HighSchoolOurTeamsCard highSchool={highSchool} />
            </div>
            <div className="right-side-profile">
                {highSchool.teams && <OurEsportsCard highSchool={highSchool} />}
                {highSchool.address && <HighSchoolLocationCard highSchool={highSchool} />}
            </div>
        </>
    );
}
